import SEO from "@modules/seo/SEO";
import HelpCenterContainer from "../components/HelpCenterContainer";
import HelpCenterImage from "../components/HelpCenterImage";
import HelpCenterLink from "../components/HelpCenterLink";
import HelpCenterText from "../components/HelpCenterText";

import useAppTranslation from "@hooks/language/useAppTranslation";
import { List, ListItem } from "@mantine/core";
import { Trans } from "react-i18next";
import img1 from "../assets/changeId_1.webp";
import img2 from "../assets/changeId_2.webp";
import img3 from "../assets/changeId_3.webp";
import HelpCenterDiscordLink from "../components/HelpCenterDiscordLink";
import HelpCenterTitle from "../components/HelpCenterTitle";

const HowToChangeRiotIdAndUsername = () => {
  const { t } = useAppTranslation("pages.helpCenter");

  return (
    <>
      <SEO
        title={t("changeRiotId.seo.title")}
        description={t("changeRiotId.seo.description")}
      />
      <HelpCenterContainer title={t("changeRiotId.title")}>
        <HelpCenterText>{t("changeRiotId.intro")}</HelpCenterText>

        <HelpCenterTitle>{t("changeRiotId.step1.title")}</HelpCenterTitle>

        <HelpCenterText>
          <Trans i18nKey="pages.helpCenter.changeRiotId.step1.text">
            Avant de pouvoir changer votre ID Riot ou votre nom d'invocateur,
            vous devez d'abord vous connecter à votre compte Riot Games.
            Rendez-vous sur la page de connexion de Riot Games ici:
            <HelpCenterLink>https://authenticate.riotgames.com/</HelpCenterLink>
            Entrez vos identifiants (identifiant et mot de passe) de votre
            compte.
          </Trans>
        </HelpCenterText>

        <HelpCenterImage src={img1} className="md:min-w-[50%]" />

        <HelpCenterTitle>{t("changeRiotId.step2.title")}</HelpCenterTitle>

        <HelpCenterText>{t("changeRiotId.step2.text")}</HelpCenterText>

        <HelpCenterTitle>{t("changeRiotId.step3.title")}</HelpCenterTitle>

        <HelpCenterText>{t("changeRiotId.step3.text1")}</HelpCenterText>

        <HelpCenterImage src={img2} />

        <HelpCenterText>{t("changeRiotId.step3.text2")}</HelpCenterText>

        <HelpCenterImage src={img3} />

        <HelpCenterText>{t("changeRiotId.step3.text3")}</HelpCenterText>

        <HelpCenterTitle>{t("changeRiotId.tips.title")}</HelpCenterTitle>

        <HelpCenterText>
          {t("changeRiotId.tips.intro")}
          <List>
            <ListItem>
              <Trans i18nKey="pages.helpCenter.changeRiotId.tips.list.originality">
                <strong>Originalité: </strong>Assurez-vous que votre nouveau nom
                est unique et mémorable.
              </Trans>
            </ListItem>
            <ListItem>
              <Trans i18nKey="pages.helpCenter.changeRiotId.tips.list.simplicity">
                <strong>Simplicité:</strong> Optez pour un nom facile à
                prononcer et à écrire.
              </Trans>
            </ListItem>
            <ListItem>
              <Trans i18nKey="pages.helpCenter.changeRiotId.tips.list.rules">
                <strong>Respect des règles: </strong>Vérifiez que votre nom ne
                viole pas les conditions d'utilisation ou les directives
                communautaires de Riot Games.
              </Trans>
            </ListItem>
          </List>
        </HelpCenterText>

        <HelpCenterTitle>{t("changeRiotId.conclusion.title")}</HelpCenterTitle>

        <HelpCenterText>
          <Trans i18nKey="pages.helpCenter.changeRiotId.conclusion.text">
            Changer votre ID Riot & votre nom d'invocateur est un processus
            simple qui peut rafraîchir votre expérience de jeu. En suivant ce
            guide, vous pouvez facilement mettre à jour votre identité en ligne
            pour mieux correspondre à vos préférences. Si vous rencontrez des
            problèmes ou avez des questions supplémentaires, n'hésitez pas à
            nous contacter via notre <HelpCenterDiscordLink />.
          </Trans>
        </HelpCenterText>
      </HelpCenterContainer>
    </>
  );
};

export default HowToChangeRiotIdAndUsername;
